import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import componentBase from '../../../../../../../../src/lib/component-base';

const defaultState = {
  elapsedSeconds: 0,
};

function toTitleCase(str) {
  return str.replace(/\w\S*/g, txt => (
    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  ));
}

@componentBase('UpdateTimer')
export default class UpdateTimer extends React.Component {
  static propTypes = {
    callbackInterval: PropTypes.number,
    callback: PropTypes.func,
  };

  constructor(props, context) {
    super(props, context);
    this.state = defaultState;
    this.timer = null;
  }

  componentDidMount() {
    this.initTimer();
  }

  componentWillReceiveProps() {
    if (this.timer) {
      this.setState(defaultState);
      this.initTimer();
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  initTimer() {
    this.stopTimer();
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  tick() {
    const newTime = this.state.elapsedSeconds + 1;
    const newState = { elapsedSeconds: newTime };
    this.setState(newState);

    if (this.props.callback &&
      this.props.callbackInterval &&
      newTime === this.props.callbackInterval) {
      this.props.callback();
    }
  }

  render() {
    // const minutes = (this.state.elapsedSeconds / 60);
    // const mm = parseInt(minutes, 10);
    // const seconds = ((minutes - mm) * 60);
    // const ss = parseInt(seconds, 10);
    // const jsxSeconds = (<span>{ss} second{ss === 1 ? '' : 's'}</span>);
    // const jsxMinutes = (minutes < 1) ? '' : (<span>{ mm } minute{mm === 1 ? '' : 's'}</span>);
    const when = moment().subtract(this.state.elapsedSeconds, 'Seconds').fromNow();
    const text = toTitleCase(`Page Updated ${when}.`);

    return (
      <span className='timer'>
        {text}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightInformation/children/UpdateTimer/UpdateTimer.js